"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelect = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var multi_select_style_1 = require("./multi-select-style");
function MultiSelect(props) {
    var _a = props.suggestions, suggestions = _a === void 0 ? [] : _a, renderItem = props.renderItem, _b = props.showHelp, showHelp = _b === void 0 ? true : _b, restProps = __rest(props, ["suggestions", "renderItem", "showHelp"]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(multi_select_style_1.StyledGlobalMultiSelect, {}), (0, jsx_runtime_1.jsx)(multi_select_style_1.StyledMultiSelect, __assign({}, restProps, { suggestions: suggestions, __experimentalAutoSelectFirstMatch: true, __experimentalExpandOnFocus: true, __experimentalShowHowTo: showHelp, __experimentalRenderItem: function (suggestionValue) {
                    if (renderItem) {
                        return renderItem(suggestionValue);
                    }
                    var item = suggestionValue.item;
                    var newValue = item;
                    suggestions.forEach(function (suggestion) {
                        if (suggestion === item) {
                            newValue = ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("strong", { children: suggestion }) }));
                        }
                    });
                    return newValue;
                } }))] }));
}
exports.MultiSelect = MultiSelect;
